<!-- Dynamic data -->
<mat-card class="box-bottom-padding-and-border">
  <div fxLayout="row" fxLayoutAlign="center">
    <!-- Altitude -->
    <div fxLayout="column" fxLayoutAlign="center center" style="width: 140px;">
      <div class="track-aro-alt">
        <img class="track-aro-alt-circle" src="./assets/Images/track-aro-alt.svg" />
        <span class="track-aro-alt-value">{{altitudeDis}}</span>
        <svg class="track-aro-alt-gauge" viewBox="0 0 179.474 178.675" width="179.474px" height="178.675px">
          <linearGradient id="gradAlt" x1="1" x2="0">
            <stop offset="0%" style="stop-color: aqua" [style.stop-opacity]="altMinOpacity" />
            <stop [attr.offset]="altPercentGrad1" style="stop-color: aqua; stop-opacity: 0.7" />
            <stop [attr.offset]="altPercentGrad2" style="stop-color: aqua; stop-opacity: 1" />
            <stop [attr.offset]="altPercentActual" style="stop-color: aqua; stop-opacity: 1" />
            <stop [attr.offset]="altPercentCutoff" style="stop-color: aqua; stop-opacity: 0" />
            <stop offset="100%" style="stop-color: aqua" [style.stop-opacity]="altMaxOpacity" />
          </linearGradient>
          <g>
            <circle #altCircle r="77" cx="89.75" cy="89.34" stroke="url(#gradAlt)" stroke-width="9" fill="none" />
          </g>
        </svg>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" [formGroup]="dynForm">
        <mat-form-field class="mat-form-field-large">
          <input #altField type="text" matInput [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskAlt" [placeholder]="'ARO.ALTITUDE' | translate" formControlName="alt"
            (input)="typingHandeling($event, 'alt')" [@blinkError]="errTransAlt ? 'red' : 'normal'">
        </mat-form-field>
      </div>
      <span class="aro-label-clickable" (click)="onAltitudeUnitChange()">({{altitudeUnits}})</span>
    </div>
    <!-- Speed -->
    <div fxLayout="column" fxLayoutAlign="center center" style="width: 140px;">
      <div class="track-aro-spd">
        <img class="track-aro-spd-circle" src="./assets/Images/track-aro-spd.svg" />
        <span class="track-aro-spd-value">{{speedDis}}</span>
        <svg class="track-aro-spd-gauge" viewBox="0 0 179.474 178.675" width="179.474px" height="178.675px">
          <linearGradient id="gradSpdLeft">
            <stop offset="0%" style="stop-color: aqua; stop-opacity: 1" />
            <stop offset="80%" style="stop-color: aqua; stop-opacity: 0.4" />
            <stop offset="100%" style="stop-color: aqua; stop-opacity: 0.2" />
          </linearGradient>
          <clipPath id="clipPathSpdLeft">
            <rect x="0" y="88" width="179" height="89" />
          </clipPath>
          <clipPath id="clipPathSpdRight">
            <rect x="0" y="0" width="179" height="90" />
          </clipPath>
          <g>
            <circle #speedCircle r="77" cx="89.75" cy="89.34" stroke="url(#gradSpdLeft)"
              clip-path="url(#clipPathSpdLeft)" [style.strokeDasharray]="speedCircleDasharray"
              [style.strokeDashoffset]="speedCircleDashoffset" stroke-width="9" fill="none" />
            <circle #speedCircle r="77" cx="89.75" cy="89.34" stroke="aqua" clip-path="url(#clipPathSpdRight)"
              [style.strokeDasharray]="speedCircleDasharray" [style.strokeDashoffset]="speedCircleDashoffset"
              stroke-width="9" fill="none" />
          </g>
        </svg>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" [formGroup]="dynForm">
        <mat-form-field class="mat-form-field-large">
          <input #spdField matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskSpd" [placeholder]="'ARO.SPEED' | translate" formControlName="spd"
            (input)="typingHandeling($event, 'spd')" [@blinkError]="errTransSpd ? 'red' : 'normal'">
        </mat-form-field>
      </div>
      <span class="aro-label-clickable" (click)="onSpeedUnitChange()">({{speedUnits}})</span>
    </div>
    <!-- Heading -->
    <div fxLayout="column" fxLayoutAlign="center center" style="width: 140px;">
      <div class="track-aro-hdg">
        <img class="track-aro-hdg-circle" src="./assets/Images/track-aro-hdg.svg" />
        <span class="track-aro-hdg-value">{{headingDis}}&deg;</span>
        <svg [style.transform]="headingRotate" class="track-aro-hdg-gauge" viewBox="0 0 179.474 178.675"
          width="179.474px" height="178.675px">
          <linearGradient id="gradHdg" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style="stop-color: aqua; stop-opacity: 0" />
            <stop offset="50%" style="stop-color: aqua; stop-opacity: 0.2" />
            <stop offset="80%" style="stop-color: aqua; stop-opacity: 0.4" />
            <stop offset="90%" style="stop-color: aqua; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: aqua; stop-opacity: 1" />
          </linearGradient>
          <g>
            <path d=" M 72 170.58 C 76.819 173.471 100.613 174.049 106.074 170.675 L 89.09 98.101 Z "
              fill="url(#gradHdg)" />
            <line x1="89.241" y1="96.951" x2="89.241" y2="7.903" />
          </g>
        </svg>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" [formGroup]="dynForm">
        <mat-form-field class="mat-form-field-large">
          <input #hdgField matInput type="number" autocomplete="off"
            class="field-input" [placeholder]="'ARO.HEADING' | translate" formControlName="hdg"
            (input)="typingHandeling($event, 'hdg')" [@blinkError]="errTransHdg ? 'red' : 'normal'">
        </mat-form-field>
      </div>
      <span class="aro-label">(DEG)</span>
    </div>
  </div>
</mat-card>